import { FEED_STATS } from './feedStatus';
import { Box, Stack } from '@presov.sk/presov-ui-react';
import React from 'react';

/**
 * Legenda kreslí len stavy, ktoré majú farbu - „Moje" ju nemá. `flatMap` a nie
 * `filter`: takto z nej vypadne zoznam, v ktorom je `family` povinná, a gulička
 * si cestu do palety poskladá bez otázky, či tam farba je.
 */
const LEGEND = FEED_STATS.flatMap((stat) =>
  stat.family ? [{ ...stat, family: stat.family }] : [],
);

/**
 * Legenda farieb značiek nad mapou. Berie tie isté tri stavy ako štatistika
 * v paneli - „Moje" v nej nie je, lebo to nie je stav, ale pohľad na zoznam.
 */
const FeedLegend: React.FC = () => (
  <Stack
    direction='row'
    className='screen-only'
    sx={(theme) => ({
      position: 'absolute',
      left: 20,
      // Rovnaké odsadenie ako tlačidlo nového podnetu na druhej strane mapy -
      // legenda s ním stojí v jednom riadku. Pod ňou zostane len drobný pás
      // zdrojov mapy (`.esri-attribution`), ktorý je nižší.
      bottom: 20,
      zIndex: 2,
      alignItems: 'center',
      gap: 1.75,
      height: theme.typography.pxToRem(38),
      padding: theme.spacing(0, 1.75),
      borderRadius: `${theme.shape.borderRadiusFull}px`,
      backgroundColor: theme.palette.background.paper,
      border: `${theme.typography.pxToRem(1)} solid ${theme.palette.divider}`,
      boxShadow: '0 6px 20px rgba(23, 21, 18, 0.08)',
      fontSize: theme.typography.pxToRem(12),
      color: theme.palette.grey[600],
    })}
  >
    {LEGEND.map((stat) => (
      <Stack
        key={stat.key}
        direction='row'
        sx={{ alignItems: 'center', gap: 0.75 }}
      >
        <Box
          sx={{
            width: 10,
            height: 10,
            borderRadius: '999px',
            backgroundColor: `${stat.family}.main`,
          }}
        />
        {stat.label}
      </Stack>
    ))}
  </Stack>
);

export default FeedLegend;
